import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: { [key: string]: string } = {}

export const { reducer, actions } = createSlice({
  name: 'selectedMutations',
  initialState,
  reducers: {
    setMutation: (state, action: PayloadAction<{ key: string; value: string }>) => {
      state[action.payload.key] = action.payload.value
    },
    unsetMutation: (state, action: PayloadAction<string>) => {
      delete state[action.payload]
    },
    bulkUnsetMutations: (state, action: PayloadAction<string[]>) => {
      action.payload.forEach(mutationId => {
        delete state[mutationId]
      })
    }
  }
})
